export default "/apps/maps/img/layers.png";